import axios from "axios";
import { useAuthStore } from "@/stores/auth.js";
import notify from "@/services/notify.js";

const instance = axios.create({
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true,
});

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) await useAuthStore().logout();
    else {
      const message = getErrorMessage(error);
      notify({ title: "Errore", status: "error", text: message });
    }
    return Promise.reject(error);
  },
);

const isNetworkError = (error) => {
  return !error.response && Boolean(error.request) && error.message === "Network Error";
};

const getErrorMessage = (error) => {
  if (isNetworkError(error)) return "Errore di rete. Controlla la tua connessione.";
  if (error.response?.data?.message) return error.response.data.message;
  if (error.message) return error.message;
  return "Contatta il supporto tecnico.";
};

export default instance;
